module.exports = __webpack_public_path__ + "static/media/Students-bro.6fee12b5.png";